import React from 'react';
import {
  Button,
  Icon,
  ScreenContainer,
  SimpleStyleScrollView,
  withTheme,
} from '@draftbit/ui';
import { Image, Text, View } from 'react-native';
import * as GlobalStyles from '../GlobalStyles.js';
import Images from '../config/Images';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import useWindowDimensions from '../utils/useWindowDimensions';

const FailureScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      style={StyleSheet.applyWidth(
        {
          backgroundColor: {
            minWidth: Breakpoints.Laptop,
            value: palettes.Brand.Background,
          },
        },
        dimensions.width
      )}
    >
      <SimpleStyleScrollView
        bounces={true}
        horizontal={false}
        keyboardShouldPersistTaps={'never'}
        nestedScrollEnabled={false}
        showsHorizontalScrollIndicator={true}
        showsVerticalScrollIndicator={true}
        style={StyleSheet.applyWidth(
          {
            flex: [
              { minWidth: Breakpoints.Laptop, value: 1 },
              { minWidth: Breakpoints.Mobile, value: 1 },
            ],
          },
          dimensions.width
        )}
      >
        {/* Logo */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: { minWidth: Breakpoints.Laptop, value: 'center' },
              alignSelf: 'center',
              justifyContent: { minWidth: Breakpoints.Laptop, value: 'center' },
              paddingTop: [
                { minWidth: Breakpoints.Laptop, value: 50 },
                { minWidth: Breakpoints.Mobile, value: 50 },
              ],
            },
            dimensions.width
          )}
        >
          {/* Image 2 */}
          <Image
            {...GlobalStyles.ImageStyles(theme)['Image'].props}
            resizeMode={'contain'}
            source={imageSource(Images['logocropped'])}
            style={StyleSheet.applyWidth(
              StyleSheet.compose(
                GlobalStyles.ImageStyles(theme)['Image'].style,
                {
                  height: [
                    { minWidth: Breakpoints.Laptop, value: 200 },
                    { minWidth: Breakpoints.Desktop, value: 200 },
                    { minWidth: Breakpoints.BigScreen, value: 250 },
                    { minWidth: Breakpoints.Mobile, value: 200 },
                  ],
                  width: [
                    { minWidth: Breakpoints.Laptop, value: 200 },
                    { minWidth: Breakpoints.Desktop, value: 200 },
                    { minWidth: Breakpoints.BigScreen, value: 250 },
                    { minWidth: Breakpoints.Mobile, value: 200 },
                  ],
                }
              ),
              dimensions.width
            )}
          />
        </View>
        {/* View 3 */}
        <View
          style={StyleSheet.applyWidth(
            { flex: 1, justifyContent: 'space-evenly' },
            dimensions.width
          )}
        >
          <View
            style={StyleSheet.applyWidth(
              {
                alignItems: [
                  { minWidth: Breakpoints.Laptop, value: 'center' },
                  { minWidth: Breakpoints.Mobile, value: 'center' },
                ],
                alignSelf: { minWidth: Breakpoints.Laptop, value: 'center' },
                gap: [
                  { minWidth: Breakpoints.Laptop, value: 20 },
                  { minWidth: Breakpoints.Mobile, value: 20 },
                ],
                justifyContent: {
                  minWidth: Breakpoints.Laptop,
                  value: 'center',
                },
              },
              dimensions.width
            )}
          >
            <Text
              accessible={true}
              selectable={false}
              {...GlobalStyles.TextStyles(theme)['Text'].props}
              style={StyleSheet.applyWidth(
                StyleSheet.compose(
                  GlobalStyles.TextStyles(theme)['Text'].style,
                  {
                    color: [
                      {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.Brand.White,
                      },
                      {
                        minWidth: Breakpoints.Mobile,
                        value: palettes.Brand.White,
                      },
                    ],
                    fontFamily: [
                      {
                        minWidth: Breakpoints.Laptop,
                        value: 'OpenSans_400Regular',
                      },
                      {
                        minWidth: Breakpoints.Mobile,
                        value: 'OpenSans_400Regular',
                      },
                    ],
                    fontSize: [
                      { minWidth: Breakpoints.Laptop, value: 35 },
                      { minWidth: Breakpoints.Mobile, value: 35 },
                    ],
                  }
                ),
                dimensions.width
              )}
            >
              {'Payment failed'}
            </Text>
            <Icon
              color={StyleSheet.getWidthValue(
                [
                  {
                    minWidth: Breakpoints.Laptop,
                    value: palettes.Brand['App Red'],
                  },
                  {
                    minWidth: Breakpoints.Mobile,
                    value: palettes.Brand['App Red'],
                  },
                ],
                dimensions.width
              )}
              name={'AntDesign/closecircle'}
              size={StyleSheet.getWidthValue(
                [
                  { minWidth: Breakpoints.Laptop, value: 100 },
                  { minWidth: Breakpoints.Mobile, value: 100 },
                ],
                dimensions.width
              )}
            />
          </View>
          {/* View 2 */}
          <View
            style={StyleSheet.applyWidth(
              {
                alignSelf: [
                  { minWidth: Breakpoints.Laptop, value: 'center' },
                  { minWidth: Breakpoints.Mobile, value: 'center' },
                ],
              },
              dimensions.width
            )}
          >
            <Button
              accessible={true}
              iconPosition={'left'}
              onPress={() => {
                try {
                  navigation.navigate('PaymentPlanSelectionScreen');
                } catch (err) {
                  console.error(err);
                }
              }}
              {...GlobalStyles.ButtonStyles(theme)['Button'].props}
              style={StyleSheet.applyWidth(
                StyleSheet.compose(
                  GlobalStyles.ButtonStyles(theme)['Button'].style,
                  {
                    backgroundColor: [
                      {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.Brand['App Blue Dark'],
                      },
                      {
                        minWidth: Breakpoints.Mobile,
                        value: palettes.Brand['App Blue Dark'],
                      },
                    ],
                    width: [
                      {
                        minWidth: Breakpoints.Laptop,
                        value: dimensions.width * (15 / 100),
                      },
                      {
                        minWidth: Breakpoints.Mobile,
                        value: dimensions.width * (25 / 100),
                      },
                    ],
                  }
                ),
                dimensions.width
              )}
              title={'Continue'}
            />
          </View>
        </View>
      </SimpleStyleScrollView>
    </ScreenContainer>
  );
};

export default withTheme(FailureScreen);
